import React from 'react';
import { Socket } from 'socket.io-client';
import { LiveResultsType } from 'types/liveResults';

export enum Actions {
  SET_CURRENT_SCREEN = 'setCurrentScreen',
  SET_SCREEN_TYPE = 'setScreenType',
  SET_TIMER = 'setTimer',
  SET_SESSION_UUID = 'setSessionUuid',
  SET_LIVE_RESULTS = 'setLiveResults',
  SET_PAUSE_TIMER = 'setPauseTimer',
  SET_JOIN_CODE = 'setJoinCode',
  SET_CONNECTION_CLOSED_VOLUNTARILY = 'setConnectionClosedVoluntarily',
  SET_SHOW_JOIN_DETAILS = 'setShowJoinDetails',
  SET_RECIEVED_FIRST_MESSAGE = 'setRecievedFirstMessage',
  SET_NOT_FOUND = 'setNotFound',
  SET_PREVIEW_CODE = 'setPreviewCode',
}

export interface ActionType {
  type: Actions;
  payload?: never;
  key?: string;
}

export interface LiveContextInterface {
  currentScreen?: string;
  screenType?: string;
  timer?: string;
  timerPausedSecondsRemaining?: number;
  sessionUuid?: string;
  dispatch?: React.Dispatch<ActionType>;
  emitLiveSubmission?: (questionUuid: string) => void;
  exitEngagement?: () => void;
  connectionClosedVoluntarily?: boolean;
  liveResults?: Map<string, LiveResultsType>;
  socket?: Socket | null;
  joinCode?: string;
  previewCode?: string;
  shortUrl?: string;
  showJoinDetails?: boolean;
  recievedFirstMessage?: boolean;
  liveDispatch?: React.Dispatch<ActionType>;
  notFound?: boolean;
}
export const LiveContext = React.createContext<LiveContextInterface>({} as LiveContextInterface);

export const LiveReducer = (state: LiveContextInterface, action: ActionType): LiveContextInterface => {
  const newResults = new Map(state.liveResults);
  switch (action.type) {
    case Actions.SET_CURRENT_SCREEN:
      return { ...state, currentScreen: action.payload };
    case Actions.SET_SCREEN_TYPE:
      return { ...state, screenType: action.payload };
    case Actions.SET_PAUSE_TIMER:
      return { ...state, timerPausedSecondsRemaining: action.payload };
    case Actions.SET_TIMER:
      return { ...state, timer: action.payload, timerPausedSecondsRemaining: 0 };
    case Actions.SET_SESSION_UUID:
      return { ...state, sessionUuid: action.payload };
    case Actions.SET_LIVE_RESULTS:
      if (action.key && action.payload) {
        newResults.set(action.key, action.payload);
      }
      return { ...state, liveResults: newResults };
    case Actions.SET_JOIN_CODE: {
      const { joinCode, shortUrl } = action.payload as unknown as { joinCode: string; shortUrl: string };
      return { ...state, joinCode, shortUrl: shortUrl.replace('https://', '').replace('http://', '') };
    }
    case Actions.SET_PREVIEW_CODE: {
      return { ...state, previewCode: action.payload };
    }
    case Actions.SET_CONNECTION_CLOSED_VOLUNTARILY: {
      return { ...state, connectionClosedVoluntarily: action.payload };
    }
    case Actions.SET_SHOW_JOIN_DETAILS: {
      return { ...state, showJoinDetails: action.payload };
    }
    case Actions.SET_RECIEVED_FIRST_MESSAGE: {
      return { ...state, recievedFirstMessage: true };
    }
    case Actions.SET_NOT_FOUND: {
      return { ...state, notFound: true };
    }
    default:
      return state;
  }
};
